"use strict";function clearShake$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.clearShake$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.accelerometer.clearShake";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.clearShake$=clearShake$,exports.default=clearShake$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/accelerometer/clearShake.js
// module id = 1039
// module chunks = 106